import React, { forwardRef, type ReactElement } from 'react';
import { Button } from '../Button/unstable/Button';

import type { SidekickProps } from './Sidekick.types';

export const Sidekick = forwardRef<HTMLElement, SidekickProps>(
  (
    {
      as: Component = 'section',
      background,
      children,
      href,
      buttonLabel,
      theme = 'dark',
      testId,
    },
    ref
  ): ReactElement => {
    return (
      <Component
        className='hds-sidekick'
        style={{
          backgroundImage: `url(${background.img.src})`,
        }}
        data-testid={testId}
        data-theme={theme}
        ref={ref}
      >
        <div className='hds-sidekick__container'>
          <div className='hds-sidekick__content'>{children}</div>
          {href && buttonLabel && (
            <div className='hds-sidekick__button-group'>
              <Button size='medium' variant='solid' href={href}>
                {buttonLabel}
              </Button>
            </div>
          )}
        </div>
      </Component>
    );
  }
);

Sidekick.displayName = 'Sidekick';
